import dynamic from 'next/dynamic';
import { QuickGroupHeaderProps } from './QuickGroupHeader.types';

export const QuickGroupHeader = dynamic<{ model: QuickGroupHeaderProps }>(() =>
  import('./QuickGroupHeader').then(mod => mod.QuickGroupHeader)
);
